// extracted by mini-css-extract-plugin
var _1 = "FileListItemSkeleton-moduleFileListItemSkeleton__mFO7n FileList-modulefileListItem__AWC2n Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "FileListItemSkeleton" }
